'use strict';

const React = require('react');
const Link = require('react-router').Link;
const PrimaryMenu = require('./PrimaryMenu');
const InfoPageMenu = require('./InfoPageMenu');
const MenuButtons = require('./MenuButtons');

const AutoCompleteSearchForm = require('./search/AutoCompleteSearchForm.jsx');
const AutoCompleteList = require('./search/AutoCompleteList.jsx');

const classnames = require('classnames');

const Menu = ({model, query, pathname, search, onSearch}) => {
	
	const showprimary = !!query && !!query.menuActive;
	const classesMenu = classnames({
		"svtse_menu": true,
		"svtse_menu--search-is-open": !!query && !!query.searchbarActive // TODO Culprit
	});
	const classesSearchColumn = classnames({
		"svtse_menu__search-column" : true,
		"svtse_menu__search-column--search-is-open" : !!query && !!query.searchbarActive
	});
	return (
		<section className="svtse_section svtse_section--white svtse_application__header-area__section">
			<div className={classesMenu} id="svtse_menu">
				<div className="svtse_menu__area">
					<div className="svtse_menu__columns">

						<div className="svtse_menu__logo-column">
							<Link className="svtse_menu__logo-link" to="/">
								<img className="svtse_menu__logo-img" src="/static/svtse-render/images/logotypes/svtlogo-black.png" alt="svt"/>
							</Link>
						</div>

						<MenuButtons model={model} search={search} onSearch={onSearch} pathname={pathname} query={query}/>

						<div className="svtse_menu__nav-column">
							<PrimaryMenu model={model} show={showprimary} />
						</div>

						<div className={classesSearchColumn}>

							<div className="svtse_menu__info-area">
								<InfoPageMenu model={model}/>
							</div>

							<div className="svtse_menu__search-area">

								<AutoCompleteSearchForm query={query} ariaControlsId="svtse_a11y-auto-complete-list" />

								<div className="svtse_menu__auto-complete-list" id="svtse_a11y-auto-complete-list">
									<AutoCompleteList />
								</div>

							</div>
						</div>

					</div>
				 </div>
			</div>
		</section>
	);
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./app/components/menu/Menu.jsx
 **/